class CheckDataProduct {
  constructor(languages) {
    this.languages = languages;
  }

  static checkMultiFields(data) {
    for (const element of data) {
      if (element && element !== 'undefined' && element !== 'undefined g' && element !== 'undefined kcal') return `(${element})`;
    }
    return '';
  }

  static checkDataSingleLanguage(data, msgIfNotFound) {
    if (data && data !== 'undefined g' && data !== 'undefined kcal') return data;
    return msgIfNotFound;
  }

  static checkAndCleanDataSingleLanguage(data, msgIfNotFound) {
    if (data) {
      const newData = data.replace(/[a-z]*:/g, '');
      return this.addSpace(newData);
    }
    return msgIfNotFound;
  }

  checkDataMultiLanguage(data, specificData, msgIfNotFound) {
    for (const idx in this.languages) {
      if (data[`${specificData}_${this.languages[idx]}`]) return data[`${specificData}_${this.languages[idx]}`];
    }
    if (data[specificData] && data[specificData] !== 'undefined') return data[specificData];
    return msgIfNotFound;
  }

  static checkMultiData(data, msgIfNotFound) {
    if (data && data.length > 0) {
      let newData = '';
      data.forEach((element) => {
        newData += `${element.material},`;
      });
      newData = newData.replace(/,$/, '');
      newData = newData.replace(/[a-z]*:/g, '');
      return this.addSpace(newData);
    }
    return msgIfNotFound;
  }

  static checkSingleDataOnArray(data, msgIfNotFound) {
    if (data && data.length > 0) {
      let newData = '';
      data.forEach((element) => {
        newData += `${element},`;
      });
      newData = newData.replace(/,$/, '');
      newData = newData.replace(/[a-z]*:/g, '');
      return this.addSpace(newData);
    }
    return msgIfNotFound;
  }

  static checkDataBrands(data) {
    if (data) return data.replace(/,.*/, '');
    return '';
  }

  static checkData(data) {
    if (data) return data;
    return false;
  }

  static isProductCode(ean) {
    return /^\d+$/.test(ean.trim());
  }

  static addSpace(data) {
    return data.replace(/,/g, ', ');
  }
}

export default CheckDataProduct;
